import Sommaire from "./docs.json";
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';

interface Article 
    {
        text: string;
        lien: string;
    }

interface Category 
    {
        text: string;
        articles: Article[];
    }

// Typage explicite pour le JSON importé avec une assertion de type
const sommaire = Sommaire as Category[];

export default function Docs() {
    // Typage explicite pour l'état categories
    const [categories, setCategories] = useState<Category[]>([]);

    useEffect(() => 
        {
            // Simule la lecture du JSON
            setCategories(sommaire);
        }, []);

    return (
        <div className='Page'>
            <h1>Cours</h1>
            <div className="sommaire">
                {categories.map((category: Category, index: number) => (
                <div key={index}>
                    <div className="categorie">{category.text}</div>
                    <div className="sousCategories">
                        {
                            category.articles.map((article: Article, subIndex: number) => 
                                (
                                    <div className="article" key={subIndex}>
                                    <div className="articleName"><Link to={article.lien}>{article.text}</Link></div>
                                    {article.lien === "/EnConstruction" ? (
                                                <div className="enConstruction">En Construction</div>
                                            ) : null}
                                    </div>
                                ))
                        }
                    </div>
                </div>
                ))}
            </div>
        </div>
  );
}
